// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"v_-z","narrowOptionButtons":"w_-z","noOptions":"x_-z"};